import { PaymentMethod } from "../payment/payment";
import { Product } from "../product/product";
import { Address } from "../user/address";
import { User } from "../user/user";

export interface Order {
  id: string;
  orderNumber: string;
  items: OrderItem[];
  customerInfo: User;
  shippingAddress: Address;
  billingAddress?: Address;
  paymentMethod: PaymentMethod;
  subtotal: number;
  shipping: number;
  tax: number;
  total: number;
  status: OrderStatus;
  createdAt: string;
  estimatedDelivery?: string;
}

export interface OrderItem {
  id: number;
  product: Product;
  quantity: number;
}

export enum OrderStatus {
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  PROCESSING = 'processing',
  SHIPPED = 'shipped',
  DELIVERED = 'delivered',
  CANCELLED = 'cancelled',
  REFUNDED = 'refunded'
}